import React, {useEffect, useState} from "react";
import GsmResultCard from "./GsmResultCard";

import {Button, Card, Modal} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {updateAnnotation} from "../actions/GsmResultsAction";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import {API, graphqlOperation} from "aws-amplify";
import {getDbStructures} from "../graphql/queries";

const image = "iVBORw0KGgoAAAANSUhEUgAAAMEAAAB4CAYAAABLh5YhAAABAElEQVR42u3TQQkAAAwDsfo33dkoLI8YOLi0DXwmAiYQAROIgAlEwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABmABMACYAE4AJwARgAjABDDnXe2hrsvixvwAAAABJRU5ErkJggg==";

const cardPositionStyle = {
    position: 'fixed',
    left: 'calc(100% - 217px)',
    zIndex: '990',
};

const cardFooterStyle = {
    paddingLeft: '0.5em',
    paddingRight: '0.5em',
    paddingBottom: '0.5em',
};

const SEARCH = "search";
const STRUCTURE_DB = "structure-db";

function GSMResultsDetailsModal({show, glycanSpectrumMatches, mz, projectId, onCancel, onSave, origAnnotationIndex, origAnnotationType}) {

    const [annotationIndex, setAnnotationIndex] = useState(origAnnotationIndex);
    const [annotationType, setAnnotationType] = useState(origAnnotationType.endsWith("SEARCH") ? SEARCH : STRUCTURE_DB);
    const [dbStructures, setDBStructures] = useState([]);

    useEffect(() => {
        const fetchDBStructures = async () => {

            API.graphql(
                graphqlOperation(getDbStructures, {mz: mz, charge: 1, projectId: projectId})
            ).then(result => {
                return result.data.getDBStructures;
            }).then(result => {

                setDBStructures(result);
            });
        };

        fetchDBStructures()
    }, [mz, projectId]);

    return <Modal show={show} size="lg" centered onHide={onCancel}>
        <Modal.Header closeButton>
            <Modal.Title>Assign Structure</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Tabs defaultActiveKey={annotationType} id="gsm-results-tab">
                <Tab eventKey={SEARCH} title="Search">
                    <div style={{overflow: "auto", maxHeight: '90vh'}}>
                        {
                            glycanSpectrumMatches.map((gsm, index) => {
                                return <div className="mx-1 d-inline-flex" key={index}>
                                    <GsmResultCard scale={0.63} index={index} assigned={annotationType === "search" && index === annotationIndex} sugarStructure={gsm.sugarStructure} gsmScore={gsm.gsmScore} handleSelectionChange={(selected) => {
                                        setAnnotationIndex(selected);
                                        setAnnotationType(SEARCH);
                                    }}/>
                                </div>;
                            })
                        }
                    </div>
                </Tab>
                <Tab eventKey={STRUCTURE_DB} title="Structure DB">
                    <div style={{overflow: "auto", maxHeight: '90vh'}}>
                        {
                            dbStructures.map((structure, index) => {
                                return <div className="mx-1 d-inline-flex" key={index}>
                                    <GsmResultCard scale={0.63} index={index} assigned={annotationType === "structure-db" && index === annotationIndex} sugarStructure={structure} gsmScore={0} handleSelectionChange={(selected) => {
                                        setAnnotationIndex(selected);
                                        setAnnotationType(STRUCTURE_DB);
                                    }}/>
                                </div>;
                            })
                        }
                    </div>
                </Tab>
            </Tabs>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={() => {
                setAnnotationIndex(origAnnotationIndex);
                return onCancel();
            }}>
                Cancel
            </Button>
            <Button variant="primary" onClick={() => onSave(origAnnotationIndex, annotationIndex, origAnnotationType, annotationType, annotationType === SEARCH ? glycanSpectrumMatches[annotationIndex].sugarStructure : dbStructures[annotationIndex])}>
                Save Changes
            </Button>
        </Modal.Footer>
    </Modal>
}

export default function GSMResultDetails() {

    const [showEditModal, setShowEditModal] = useState(false);
    const dispatch = useDispatch();
    const annotatedGsmResultList = useSelector(state => state.gsmResultsReducer.annotatedGsmResultList);
    const renderWithGSMs = (sugarStructure, gsmScore) => {
        return (
            <div className="d-flex" style={cardPositionStyle}>
                <GsmResultCard scale={0.5} edit={true} sugarStructure={sugarStructure} gsmScore={gsmScore} handleEditModalShow={() => setShowEditModal(true)}/>
            </div>
        );
    };

    const renderNoResults = () => {
        return (
            <div className="d-flex my-1" style={cardPositionStyle}>
                <Card bg="light" border="info" className="my-1">

                    <Card.Img src={`data:image/png;base64, ${image}`}/>
                    <small className="text-muted" style={cardFooterStyle}>
                        <Card.Text>
                            <Card.Link className="float-right" href="#" onClick={() => setShowEditModal(true)}>Edit</Card.Link>
                        </Card.Text>
                    </small>
                </Card>
            </div>
        );
    };

    function onSave(origAnnotationIndex, annotationIndex, origAnnotationType, annotationType, selectedStructure) {

        if(origAnnotationIndex === annotationIndex && origAnnotationType === annotationType)
            return;

        if (annotationType === SEARCH) {

            const variables = {
                projectId: annotatedGsmResultList.projectId,
                runId: annotatedGsmResultList.runId,
                preClusterId: annotatedGsmResultList.preClusterId,
                clusterId: annotatedGsmResultList.clusterId,
                massGroup: annotatedGsmResultList.massGroup,
                annotationType: 'CURATED_SEARCH',
                annotationIndex: annotationIndex,
                metaScore: annotatedGsmResultList.glycanSpectrumMatches[annotationIndex].gsmScore,
                sugarStructure: selectedStructure
            };
            dispatch(updateAnnotation(variables))
        } else if(annotationType === STRUCTURE_DB) {

            const variables = {
                projectId: annotatedGsmResultList.projectId,
                runId: annotatedGsmResultList.runId,
                preClusterId: annotatedGsmResultList.preClusterId,
                clusterId: annotatedGsmResultList.clusterId,
                massGroup: annotatedGsmResultList.massGroup,
                annotationType: 'CURATED_DB',
                annotationIndex: annotationIndex,
                metaScore: 1.0,
                sugarStructure: selectedStructure
            };
            dispatch(updateAnnotation(variables))
        }
        return setShowEditModal(false);
    }

    if (annotatedGsmResultList) {

        const glycanSpectrumMatches = annotatedGsmResultList.glycanSpectrumMatches;

        return <>
            {glycanSpectrumMatches.length === 0 ? renderNoResults() : renderWithGSMs(annotatedGsmResultList.annotatedStructure, annotatedGsmResultList.metaScore)}

            <GSMResultsDetailsModal glycanSpectrumMatches={glycanSpectrumMatches} projectId={annotatedGsmResultList.projectId} mz={annotatedGsmResultList.massGroup + 0.2} show={showEditModal} onCancel={() => setShowEditModal(false)} onSave={onSave}
                                    origAnnotationIndex={annotatedGsmResultList.annotationIndex} origAnnotationType={annotatedGsmResultList.annotationType}/>
        </>
    } else {

        return <div/>
    }
}